import { useState } from "react";

export function CopyButton({ text, label = "Copy" }: { text: string; label?: string }) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard permissions can be denied by the browser; fail quietly,
      // the text is still selectable/visible for a manual copy.
    }
  }

  return (
    <button type="button" className="btn btn-sm" onClick={handleCopy}>
      {copied ? "Copied" : label}
    </button>
  );
}
